import script from "./SmallButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmallButton.vue?vue&type=script&setup=true&lang=ts"

import "./SmallButton.vue?vue&type=style&index=0&id=4f145a07&lang=scss"

const __exports__ = script;

export default __exports__